import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { useEffect, useState } from 'react';
import { customColors } from '../utilities';
import { useQueryParams } from '../hooks/misc';
import { styles } from '../utilities/pdf_export/constants';

export default function DocumentTabSystem({ options }) {
  const { upsertParam, getParam } = useQueryParams();
  const section = getParam('section');
  const [value, setValue] = useState(section || options[0]?.key);

  const handleChange = (event, newValue) => {
    setValue(newValue);
    upsertParam('section', newValue);
  };

  useEffect(() => {
    if (!!section && section !== value) {
      setValue(section);
    }
  }, [section, value]);

  const currentTab = options.find((o) => o.key === value);

  return (
    <div className={styles.tabs}>
      <Tabs
        value={value}
        onChange={handleChange}
        aria-label="folder tabs"
        variant="scrollable"
        scrollButtons="auto"
        sx={{
          minHeight: 0,
          '& .MuiTabs-indicator': {
            display: 'none',
          },
          marginRight: 'auto',
        }}
      >
        {options.map((o) => {
          if (!!o.hide) return null;
          return (
            <Tab
              key={o.key}
              value={o.key}
              sx={{
                minHeight: 0,
                minWidth: 100,
                px: 3,
                py: 1.5,
                borderTopLeftRadius: 6,
                borderTopRightRadius: 6,
                fontWeight: value === o.key ? 700 : 400,
                color: customColors.SECONDARY,
                '&.Mui-selected': {
                  color: 'black !important',
                },
                position: 'relative',
                bgcolor: value === o.key ? 'white' : 'transparent',
                border:
                  value === o.key
                    ? `1px solid ${customColors.SECONDARY_LIGHT}`
                    : '1px solid transparent',
                borderBottom: '1px solid transparent',
                borderColor:
                  value === o.key
                    ? 'divider divider transparent'
                    : 'transparent',
                transition: 'background 0.18s, color 0.18s',
              }}
              label={`${o.title} ${o.count ? `(${o.count})` : ''}`}
            />
          );
        })}
      </Tabs>
      <div>{currentTab && currentTab.component}</div>
    </div>
  );
}
